import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { ReportsList } from "@/reports/ReportsList";

export const Route = createFileRoute("/(authed)/_layout/reports/")({
  component: ReportsIndex,
});

function ReportsIndex() {
  return (
    <>
      <PageHeader>
        <PageHeader.Content>
          <PageHeader.Title>Reports</PageHeader.Title>
          <PageHeader.Description>View and analyze your business data with interactive reports.</PageHeader.Description>
        </PageHeader.Content>
      </PageHeader>
      <div className="container mx-auto p-6">
        <ReportsList />
      </div>
    </>
  );
}
